import { BrowserRouter, Route, Routes } from "react-router-dom";
import NavBar from "../components/NavBar";
import HabilitacionForm from "../components/HabilitacionForm";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/styles.scss";
import Auth from '../pages/auth'
import { useEffect, useState } from "react";
import { PrivateRoute } from "./privateRoute/PrivateRoute";
import { Options } from "../pages/viewOptions/viewOptions";
import RenovationForm from "../components/RenovationForm";

const App = () => {
  const [data, setData] = useState(false);
  useEffect(() => {
    const dataStorage = localStorage.getItem("data");
    setData(JSON.parse(dataStorage));
  }, []);

  return (
    <BrowserRouter>
      <NavBar />
      <Routes>
        <Route exact path="/" element={<Auth data={data} />} />

        <Route
          path="/transporte"
          element={
            <PrivateRoute>
              <Options  isAuth={data && data?.idrafam !== "0"}/>
            </PrivateRoute>
          }       
        />
        <Route
          path="/habilitacion"
          element={
            <PrivateRoute>
              <HabilitacionForm  isAuth={data && data?.idrafam !== "0"} />
            </PrivateRoute>
          }     
        />
        <Route
          path="/renovacion"
          element={
            <PrivateRoute>
              <RenovationForm  isAuth={data &&  data?.idrafam !== "0"} />
            </PrivateRoute>
          }     
        />
        
      </Routes>
    </BrowserRouter>
  );
};

export default App;
